<div class="main-content-container">
  <form [formGroup]="scoreForm">
    @if (radio_support) {
      <div class="container-fluid">
        <div class="row" [ngClass]="getDivClass()">
          @for (row of scoreField; track row; let i = $index) {
            <div class="{{className}}" formArrayName="rows">
              <ng-container [formGroupName]="i">
                <div class="border-bottom p-2 mt-3">{{label[i]}}</div>
                <div class="form-radio radio col-12">
                  <p [ngClass]="row.scoreNote ? 'scoreNote' : ''">{{row.scoreNote}}</p>
                  <div class="d-flex justify-content-between">
                    @if (row && row.is_numeric_value) {
                      <div style="font-weight: 500">
                        Numeric Value
                      </div>
                    }
                    @if (row && row.is_numeric_value) {
                      <div class="col-md-5 col-sm-5 col-lg-5 col-12">
                        <input id="numeric_value" value="numeric_value" class="form-control" type="number"
                          formControlName="numeric_value" (change)="valueChange($event,row,i)">
                      </div>
                    }
                  </div>
                  @for (option of row.scoreFieldData; track option) {
                    <div (change)="onChange($event,row,i)"
                      class="kx-radio-main-wrapper border-bottom p-2">
                      <label class="col-8 kx-radio-wrapper">{{option.data}}
                        <input type="radio" [value]="option.data" [id]="option.data" formControlName="score"
                          [attr.disabled]="row && row.is_numeric_value ? '' : null">
                        <span class="kx-radio-check"></span>
                      </label>
                      <label class="col-4 text-right">
                        <span>{{option.score}}</span>
                      </label>
                    </div>
                  }
                </div>
              </ng-container>
            </div>
          }
        </div>
      </div>
    }

    @if (!radio_support) {
      <div class="col-sm-12 col-md-12 col-lg-12 col-12 p-0">
        <div class="table-responsive">
          <table class="table">
            <thead class="text-nowrap">
              <th>Score Name</th>
              @if (isNumericVal) {
                <th>Numeric Value</th>
              }
              <th>Score Option </th>
              <th>Score Value</th>
              <th></th>
            </thead>
            <tbody>
              @for (row of scoreField; track row; let i = $index) {
                <ng-container formArrayName="rows">
                  <tr [formGroupName]="i">
                    <td style="padding-top: 1.3em;">
                      <span>{{label[i]}}</span>
                    </td>
                    @if (isNumericVal && (row && !row.is_numeric_value)) {
                      <td></td>
                    }
                    @if (row && row.is_numeric_value) {
                      <td>
                        <input id="numeric_value" value="numeric_value" class="form-control" type="number"
                          formControlName="numeric_value" (change)="valueChange($event,row,i)">
                      </td>
                    }
                    <td>
                      <input type="hidden" formControlName="scoreLabel">
                      @if (row?.is_multi_value) {
                        @if (current_action != 'VIEW') {
                          <dhs-multi-dropdown
                            [formControlName]="'score'"
                            [id]="'score'"
                            [options]='row.scoreFieldData'
                                            [question]='{
                                                getterKey: "data",
                                                getterValue: "data",
                                                options: row.scoreFieldData,
                                            }'
                            [config]="question.config"
                            [maxSelected]="null"
                            (multiChange)="onMultiDropdownChange($event, i)">
                          </dhs-multi-dropdown>
                        }
                      } @else {
                        @if (current_action != 'VIEW') {
                          <select class="form-control" formControlName="score" (change)="onChange($event,row,i)"
                            [attr.disabled]="row && row.is_numeric_value ? '' : null">
                            <option value="">Select</option>
                            @for (option of row.scoreFieldData; track option) {
                              <option [value]="option.data" [id]="option.data">
                                {{option.data}}
                              </option>
                            }
                          </select>
                        }
                      }
                      @if (current_action == 'VIEW') {
                        @if (row.controls.scoreField) {
                          <span>{{row.controls.scoreDisplayVal.value}}
                          </span>
                        }
                      }
                    </td>
                    <td>
                      @if (current_action == 'VIEW') {
                        @if (row.controls.scoreField) {
                          <span>{{row.controls.scoreField.value}} </span>
                        }
                      }
                      @if (current_action != 'VIEW') {
                        <input type="text" class="form-control" formControlName="scoreField" disabled>
                      }
                    </td>
                  </tr>
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
    <div class="row mt-3">
      <div class="col-md-3 col-sm-3 col-lg-3 col-12 text-center"><strong>Total Score: {{sum}}</strong></div>
      @if (isScoreData) {
        <div class="col-md-5 col-sm-5 col-lg-5 col-12">
          @if (current_action != 'VIEW') {
            <select class="form-control" id="risk" [(ngModel)]="risk"
              [ngModelOptions]="{standalone: true}" [attr.disabled]="totalScoreDisable ? '' : null" (change)="onRiskValSelect($event)">
              <option value="">Select</option>
              @for (option of riskData; track option; let index = $index) {
                <option [value]="option.riskLevel">
                {{option.riskLevel}}</option>
              }
            </select>
          }
          @if (current_action == 'VIEW') {
            @if (riskLevel != undenfined) {
              <span>{{riskLevel}} </span>
            }
          }
        </div>
      }
    </div>

  </form>
</div>